import Image from 'next/image';
import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';

const MetabaseText = () => {
    const { t } = useTranslations();
    return (
        <section className="about-area ptb-100 metabase-text">
            {/* Dekorative Hintergrund-Elemente */}
            <div className="metabase-text__decoration metabase-text__decoration--top-left"></div>
            <div className="metabase-text__decoration metabase-text__decoration--bottom-right"></div>

            <div className="container metabase-text__container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-content">
                            <span className="metabase-text__badge">
                                {t("metabase_metabaseText_subTitle")}
                            </span>
                            <h2 className="metabase-text__title">
                                {t("metabase_metabaseText_title")}
                            </h2>
                            <p className="metabase-text__description">
                                {t("metabase_metabaseText_text")}
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="about-image metabase-text__image-wrapper">
                            {/* Dekorative Elemente */}
                            <div className="metabase-text__image-decoration metabase-text__image-decoration--top-right"></div>
                            <div className="metabase-text__image-decoration metabase-text__image-decoration--bottom-left"></div>

                            {/* Hauptbild-Container */}
                            <div className="metabase-text__image-card">
                                <Image
                                    src="/images/business-analytics/metabase/metabase-logo.svg"
                                    alt="simplify data - Metabase Entwicklung"
                                    width={0}
                                    height={0}
                                    sizes="100vw"
                                    style={{
                                        width: '100%',
                                        height: 'auto'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MetabaseText;
